const AntIcon = ({ iconPath, classes }) => {
    return <span className={"anticon ant-menu-item-icon " + classes}><img src={iconPath} alt="Icon" /></span>
}

export default AntIcon